import parsePhoneNumber, { PhoneNumber } from 'libphonenumber-js';

import { User } from '../types';

export const typeGuards = {
  isUser: (object: unknown): object is User => {
    return (
      (object as User).email !== undefined &&
      (object as User).given_name !== undefined &&
      (object as User).family_name !== undefined &&
      (object as User).phone_number !== undefined &&
      (object as User).user_roles !== undefined
    );
  },
};

export const parsingHelpers = {
  extractPartsFromFullPhoneNumber: (phoneNumber: string): PhoneNumber | undefined => parsePhoneNumber(phoneNumber),
};

export const isNumeric = (num: unknown) => num !== null && !isNaN(Number(num));
